<template>
	<div class="b-productCard b-productCard_order b-productCard_line b-productCard_modal" itemscope
	     itemtype="http://schema.org/Product"
	     :id="product.areaId">
		<a :href="product.detailPageUrl" class="b-productCard__top">
			<div class="b-productCard__front">
				<picture class="b-productCard__imgWrap">
					<source v-if="product.picture && product.picture.hasOwnProperty('webp')" :srcset="product.picture.webp"
					        type="image/webp">
					<img class="b-productCard__img" :src="product.picture ? product.picture.src : product.picture_src" :alt="product.name"/>
				</picture>
			</div>
		</a>
		<div class="b-productCard__bottom">
			<div class="b-productCard__title" itemprop="name" v-html="product.name"></div>
			<div class="b-productCard__content">
				<citrus-product-basket-quantity-button
					:measure="product.measure"
					:metric-goal="metricGoal"
					:product-id="product.id"
					:init-quantity="quantity"
					:class="'b-productCard__counter'"
				></citrus-product-basket-quantity-button>
				<citrus-product-basket-price
					:base-price="product.price.full"
					:discount-price="basketPrice"
					:class="'b-price_productCard b-productCard__price'"
				></citrus-product-basket-price>
			</div>
		</div>
	</div>
</template>

<script>
import {Vue} from "ui.vue";
import "citrus.vuex.store";
import "citrus.vue.product.basket-button";

import CitrusProductBasketQuantityButton from "./CitrusProductBasketQuantityButton.vue";

export default {
	name: "CitrusProductPopupItem",
	store: BX.Citrus.Vuex.store,
	components: {
		CitrusProductBasketQuantityButton
	},
	props: {
		product: {
			type: Object,
			default: () => {
				return {
					areaId: "",
					id: "",
					name: "",
					detailPageUrl: "",
					picture: {
						src: "",
						width: 0,
						height: 0,
					},
					price: {
						price: 0,
						full: 0,
						in_basket: false,
					},
					weight: 0,
					measure: {
						id: 0,
						name: "",
						value: "",
						ratio: "",
					},
				}
			}
		},
		metricGoal: {
			type: [Boolean, String],
			default: false
		}
	},
	data: function () {
		return {
			loading: false
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_ITEM_");
		},
		quantity() {
			return parseInt(this.$store.getters['basket/quantity'](this.product.id));
		},
		basketPrice() {
			let quantity = parseInt(this.$store.getters['basket/quantity'](this.product.id));

			return quantity > 0
				? quantity * this.product.price.price
				: this.product.price.price;
		}
	}
}
</script>